<template>
  <div class="strategy-item" :class="{selected}">
    <div class="strategy-item__header">
      <div class="strategy-item__header__avatar">
        <img class="avatar" :src="avatar" :alt="data.type" />
      </div>
      <div class="strategy-item__header__content">
        <div class="strategy-item__header__content__name">{{data.name}}</div>
        <div class="strategy-item__header__content__time">用时 {{data.time}}</div>
      </div>
      <div class="strategy-item__header__type">{{data.type}}</div>
    </div>

    <div class="strategy-item__progress">
      <div class="strategy-item__progress__content">
        <ProgressLine :value="progressNumber" />
        <div class="strategy-item__progress__text">
          <div
            class="strategy-item__progress__text__left"
            :class="{wait: data.status === '等待中'}"
          >{{ data.status === '等待中'? `${data.stockCount}只股票等待回测` : `已完成 ${progressNumber}%`}}</div>
          <div class="strategy-item__progress__text__right">共{{data.items}}项</div>
        </div>
      </div>
      <div
        class="strategy-item__progress__status"
        :class="{process: data.status=== '回测中',finish: data.status === '已完成'}"
      >{{data.status}}</div>
    </div>
  </div>
</template>

<script>
import ProgressLine from "@/components/common/ProgressLine.vue";
import python from "@/assets/images/python.png";
import vba from "@/assets/images/vba.png";
import c from "@/assets/images/c++.png";

export default {
  name: "StrategyItem",
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          type: "Python",
          time: "00:00:00",
          progress: 30,
          name: "",
          items: 16,
          stockCode: 1000,
          status: "回测中"
        };
      },
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    progressNumber: function() {
      return Number(((this.data.progress / this.data.items) * 100).toFixed(0));
    },
    avatar: function() {
      let type = this.data.type;
      let image = null;
      switch (type) {
        case "C++":
          image = c;
          break;
        case "PYTHON":
          image = python;
          break;
        case "VBA":
          image = vba;
          break;
        default:
          throw new Error(`没有${type}类型的图片`);
      }
      return image;
    }
  },
  components: {
    ProgressLine
  }
};
</script>

<style lang="less" scoped>
.strategy-item {
  padding: 1.25rem 1.25rem 0 1.25rem;
  display: flex;
  flex-direction: column;
  height: 8.38rem;
  box-sizing: border-box;
  transition: background-color linear 0.15s;
  position: relative;

  @media screen and (max-width: 1440px) {
    padding: 0.53rem 0.53rem 0 0.53rem;
  }

  &:hover {
    cursor: pointer;
    background-color: rgba(78, 113, 230, 0.15);
  }
  &.selected {
    background-color: rgba(78, 113, 230, 0.15);

    &::after {
      content: "";
      display: block;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 0.25rem;
      height: 5.63rem;
      background: rgba(78, 114, 231, 1);
      border-radius: 0.13rem;
    }
  }

  &__header {
    display: flex;
    flex-direction: row;

    &__avatar {
      width: 2rem;
      & > img.avatar {
        width: 2rem;
        height: 2rem;
      }
    }

    &__content {
      width: 13.75rem;
      margin-left: 0.63rem;

      &__name {
        font-size: 0.88rem;
        line-height: 2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 2rem;
      }

      &__time {
        color: #cad0d5;
        font-size: 0.75rem;
      }
    }

    &__type {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #cad0d5;
      font-size: 0.75rem;
    }
  }

  &__progress {
    display: flex;
    flex-direction: row;
    margin-top: 1.31rem;

    &__text {
      display: flex;
      font-display: row;
      font-size: 0.75rem;
      color: #9eabbe;
      margin-top: 0.69rem;

      &__left {
        width: 65%;
        text-align: left;
        color: #4d71e5;
        font-size: 0.75rem;
        word-break: keep-all;

        &.wait {
          color: #9eabbe;
        }
      }
      &__right {
        flex: 1;
        text-align: right;
      }
    }

    &__content {
      width: 13.75rem;
    }

    &__status {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 0.75rem;
      color: #9eabbe;

      &.process {
        color: #01b377;
      }
      &.finish {
        color: #4d71e5;
      }
    }
  }
}
</style>